import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/exercise'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(exercise) {
    return http.post(`${resource}`, exercise)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  getMultiple(exerciseUuid, studentUuid) {
    return http.get(`${resource}/${exerciseUuid}/student/${studentUuid}`)
  },
  update(exercise, uuid) {
    return http.put(`${resource}/${uuid}?_method=PATCH`, exercise)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
